// ✅ US Market Cookies Info - Thin Wrapper (DRY principle)
import CookiesInfoPage from '../../sub/cookies-info';
import SEOHead from '../../../components/SEOHead';

export default function USCookiesInfo() {
  return (
    <>
      <SEOHead
        title='Cookies Policy | LBVisible'
        description='Information about how we use cookies on our website.'
        keywords='cookies policy, privacy, data protection'
        canonicalUrl='/us/sub/cookies-info'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/cookies-info' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/cookies-info' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/slapukai' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/cookies-info' },
        ]}
      />

      <CookiesInfoPage />
    </>
  );
}
